
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7935"}},[_c('path',{attrs:{"data-name":"Path 25843","d":"M16.142 9l-1.53 1.53 3.273 3.273H9v2.164h8.831l-3.219 3.219 1.53 1.53L22 14.858z","fill-rule":"evenodd"}})])])
          )
        }
      }
    